<nav class="navbar navbar-fixed-top white-bg" role="navigation" style="margin-bottom: 0">
  <div class="navbar-header mobile-none">
    <span class="profile-element">
      <a href="/">
        <img src="assets/images/SMG_colorfull.png" alt="Logo SMG">
      </a>
    </span>
  </div>

  <button type="button" class="menu_hamburguer" (click)="toggleNavigation()">
    <img src="assets/images/svgs/menu.svg" alt="Menu">
  </button>

  <span class="profile-element logo-mobile">
    <a href="/">
      <img src="assets/images/SMG_color.png" alt="Logo SMG">
    </a>
  </span>

  <ul class="nav navbar-top-links navbar-right">
    <li class="dropdown" dropdown>
      <a href dropdownToggle (click)="false" title="Usuário conectado">
        <div class="position-relative">
          <img src="assets/images/svgs/person.svg" alt="icone usuario">
          <div class="notification-icon" *ngIf="hasSupport || hasSupportLocal || hasSupportGeral">
            <span class="pulse"></span>
          </div>
        </div>
        <div class="info_user nome-user">
          <div class="nome">{{ nomeUsuario }}</div>
          <div class="orgao" *ngIf="orgaoUsuario">{{ orgaoUsuario }}</div>
          <b *ngIf="entidades?.length > 0">{{lebelEntidade}}</b>
        </div>
        <img class="expandir" src="assets/images/svgs/Expandir.svg" alt="Expandir">
      </a>
      <ul *dropdownMenu class="dropdown-menu animated fadeInRight" role="menu">
        <li>
          <a href="javascript:void(0)" (click)="alterarEnteFederativo()" class="dropdown-item">
            <img src="assets/images/svgs/person.svg" alt="Alterar Senha">Trocar SMG
          </a>
        </li>    
        <li>
          <a href="javascript:void(0)" (click)="alterarSenha()" class="dropdown-item">
            <img src="assets/images/svgs/person.svg" alt="Alterar Senha">Alterar Senha
          </a>
        </li>        
        <li>
          <a href="javascript:void(0)" (click)="vincularSoe()" class="dropdown-item">
            <img src="assets/images/svgs/key.svg" alt="Vincular SOE">Vincular SOE
          </a>
        </li>
        <li>
          <a [routerLink]="['/suporte','meus-suportes']" class="dropdown-item">
            <div class="dropdown-div-icon">
              <span class="font-icon dropdown-icon" alt="Meus Suportes">contact_support</span>
              <div class="notification-icon" *ngIf="hasSupport">
                <span class="pulse"></span>
              </div>
            </div>
            Meus Suportes
          </a>
        </li>
        <li *ngIf="hasPermissionSupportLocal">
          <a [routerLink]="['/suporte','local']" class="dropdown-item">
            <div class="dropdown-div-icon">
              <span class="font-icon dropdown-icon" alt="Suportes Locais">support_agent</span>
              <div class="notification-icon" *ngIf="hasSupportLocal">
                <span class="pulse"></span>
              </div>
            </div>
            Suportes Locais
          </a>
        </li>
        <li *ngIf="hasPermissionSupportGeral">
          <a [routerLink]="['/suporte','geral']" class="dropdown-item">
            <div class="dropdown-div-icon">
              <span class="font-icon dropdown-icon geral-suport-icon" alt="Suportes Locais">support_agent</span>
              <div class="notification-icon" *ngIf="hasSupportGeral">
                <span class="pulse"></span>
              </div>
            </div>
            Suportes Gerais
          </a>
        </li>
        <li>
          <a (click)="signout()" class="dropdown-item">
            <img src="assets/images/svgs/sair.svg" alt="Logout"> Sair
          </a>
        </li>
      </ul>
    </li>

    <!-- <li class="dropdown" dropdown>
      <a class="count-info" href dropdownToggle (click)="false" title="Notificações">
        <img src="assets/images/icons/Notificacoes.svg" alt="Notificacoes"><span class="label label-danger">2</span>
      </a>
      <ul *dropdownMenu class="dropdown-menu dropdown-alerts animated fadeInRight dropdown-menu-right" role="menu">
        <li>
          <a href="#" class="dropdown-item">
            <div>
              <i class="fa fa-edit fa-fw"></i> Você possui 1 processo para sua
              aprovação.
              <span class="pull-right text-muted small">40 minutos atráz</span>
            </div>
          </a>
        </li>
        <li class="divider dropdown-divider"></li>
        <li>
          <a href="#" class="dropdown-item">
            <div>
              <i class="fa fa-download fa-fw"></i> O relatório de turmas está
              disponível para download.
              <span class="pull-right text-muted small">30 minutos atraz</span>
            </div>
          </a>
        </li>
        <li class="divider dropdown-divider"></li>
        <li>
          <a href="#" class="dropdown-item">
            <div>
              <i class="fa fa-check fa-fw"></i> Novo curso aprovado.
              <span class="pull-right text-muted small">1 dia atráz</span>
            </div>
          </a>
        </li>
        <li class="divider dropdown-divider"></li>
        <li>
          <div class="text-center link-block">
            <a href="#" class="dropdown-item">
              <strong>Ver todas notificações</strong>
              <i class="fa fa-angle-right"></i>
            </a>
          </div>
        </li>
      </ul>
    </li> -->
  </ul>
</nav>

<app-loading [loader]="isLoading"></app-loading>

<ng-template #modalEnte>
  <header class="modal-header">
    <h4 class="modal-title pull-left">Mudar Ente Federativo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </header>
  <main class="p-3">
    <ng-select id="entidade" class="ng-select-alternative" [items]="entidades" bindLabel="label" bindValue="id" 
			[(ngModel)]="entidade" placeholder="Selecionar o Ente Federativo">
		</ng-select>
  </main>
  <footer class="d-flex justify-content-end p-3">
    <button class="btn btn-primary" (click)="setEntidade()">Trocar</button>
  </footer>
</ng-template>